
const MenuBuilderObjects = {

    dropdown: {
        label: '{{lang}}Drop down',
        type: 'dropdown',
        icon: '/assets/icons/useful/down-arrow (2).png',

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Menu Label', defaultValue: '{{lang}}Label' } },
        ],
    },


    page: {
        label: '{{lang}}Yonnect page',
        type: 'page',
        icon: '/assets/icons/useful/website.png',

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Menu Label', placeholder: '{{lang}}Label' } },
            { type: 'AdvancedMultiTreeSelect', key: 'page', information: { isSearchable: true, label: '{{lang}}Page', address: 'getFramesApplet', filter: { appletPopulate: true, type: 'page' }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type' }, type: 'api', placeholder: '{{lang}}Select Collection', required: false }, },
        ],
    },


    link: {
        label: '{{lang}}Link',
        type: 'link',
        icon: '/assets/icons/useful/link (2).png',

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Menu Label', placeholder: '{{lang}}Label' } },
            { type: 'TextInput', key: 'url', information: { required: true, label: '{{lang}}URL', placeholder: 'https://mydomain.com' } },
        ],
    },


    action: {
        label: '{{lang}}Action',
        type: 'action',
        icon: '/assets/icons/useful/thunder.png',

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Menu Label', defaultValue: '{{lang}}Label' } },
        ],
    },


}

const MenuBuilderItems = Object.values(MenuBuilderObjects)

export { MenuBuilderItems, MenuBuilderObjects }